
import { Component, Vue } from 'vue-property-decorator'
import DealList from '@/components/company/deal/DealList.vue'

@Component({
  name: 'deals',
  components: { DealList }
})
class Deals extends Vue {}

export default Deals
